/**
 * 拓扑插件-拓扑预览交互定义
 */

export default {
  name: 'custom-preview-canvas',
  options: {
    
  }
};
